export default __webpack_public_path__ + "static/media/Frame 11.2942b13b.svg";